import React from 'react';
export function AudienceIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("g", {
    clipPath: "url(#svg__3ef29__clip0)"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8.5c0 3.13-1.547 5.814-3.94 6.937.219.734 1.01 1.027 1.897 1.356C13.359 17.313 15 17.922 15 20.5V23H0v-2.5c0-2.578 1.641-3.187 3.043-3.707.887-.329 1.678-.622 1.897-1.356C2.547 14.314 1 11.63 1 8.5 1 4.358 3.364 1 7.5 1S14 4.358 14 8.5zM7.5 14c2.39 0 4.5-2.14 4.5-5.5 0-1.71-.489-3.108-1.248-4.039C10.027 3.573 8.972 3 7.5 3c-1.473 0-2.527.573-3.252 1.461C3.488 5.391 3 6.791 3 8.5 3 11.86 5.11 14 7.5 14z"
  }), React.createElement("path", {
    d: "M13.575 15.691c.6.201 1.245.309 1.925.309.615 0 1.202-.088 1.754-.254.21.465.538.833.927 1.124.48.36 1.097.627 1.596.842l.313.137c.605.273 1.057.528 1.374.893.288.331.536.837.536 1.758v.5h-4v2h6v-2.5c0-1.33-.377-2.323-1.027-3.07-.62-.714-1.418-1.114-2.063-1.404-.163-.074-.313-.14-.452-.2-.47-.206-.805-.352-1.077-.556-.162-.122-.274-.243-.332-.42C20.87 13.524 22 11.176 22 8.5 22 4.358 19.636 1 15.5 1a6.75 6.75 0 00-1.834.244 9.863 9.863 0 011.137 1.802c.221-.03.453-.046.697-.046 1.473 0 2.527.573 3.252 1.461.76.93 1.248 2.33 1.248 4.039 0 3.36-2.11 5.5-4.5 5.5-.266 0-.528-.027-.784-.078a10.52 10.52 0 01-1.14 1.77z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "svg__3ef29__clip0"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}